import React from 'react'
import styled from 'styled-components'

import { MagnifyingGlass } from '../icons/MagnifyingGlass'
import { theme } from '../../constants/theme'

import { Margin } from './Margin'
import { SearchInput } from './SearchInput'


export const ListSearch = (props) => (
  <InputWrapper>
    <CustomSearchInput {...props} />
    <Margin h={15} />
    <MagnifyingGlass />
  </InputWrapper>
)

const CustomSearchInput = styled(SearchInput)`
`
const InputWrapper = styled.div`
  display: flex;
  width: 239px;
  align-items: center;
  color: ${theme.colors.grayDark};
  background: ${theme.colors.white};
  padding: 10px;
  border-radius: 5px;
  filter: drop-shadow(0px 20px 100px rgba(0, 0, 0, 0.1));
`
